export const awsAuth = {
  identityPoolId: "us-east-2:4c04d0eb-76c7-4fdf-9ce9-da1d3f931ded",
  region: "us-east-2",
  identityPoolRegion: "us-east-2",
  userPoolId: "us-east-2_qQImCgx27",
  userPoolWebClientId: "35brci0r1qur96j5hkmmjvan60",
  mandatorySignIn: true,
  authenticationFlowType: "USER_PASSWORD_AUTH",
};

export const lambdaBaseUrl = "https://lambda.mylongbow.com";
export const graphqlBaseUrl = "https://api.mylongbow.com";

export const stripeKey =
  "pk_live_51IO7WMAqvgdIV2MdotuIX00lmjufGU96A1I9LF6RaDWp63c5QrqssDQZJptUr1sFEtlpiKnmCKstpIEr77dl52ww00LMJKEOxs";
